import styled from '@emotion/styled';
import { StyledRichText } from '~/shared/components/RawHtml/styled';

export const StyledM110Tally = styled.div<{ textColor: string }>(({ textColor, theme }) => ({
    color: textColor,

    [`${StyledRichText}`]: {
        color: textColor,
    },

}));

